import React from 'react'

import ReloadButton from '@/components/misc/ErrorMessage/components/ReloadButton'
import { Heading } from '@/components/ui/heading'

const OfflineMessage: React.FC = () => (
  <section className="relative">
    <Heading size={2}>Oops.</Heading>

    <ReloadButton />

    <p className="mb-0">
      It seems there's a problem with your network. Please check your internet
      connection and then try refreshing the page.
    </p>
  </section>
)

export default OfflineMessage
